<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <article class="form-heading title-section form-section flex">
            <h1 class="form-title" style="width: 345px;">Your Premium Proposal</h1>
            <img
              src="../../../public/assets/images/financial.png"
              class="title-section-img form-title-img financial-section-img"
              alt="background image"
            >
          </article>
          <article class="d-flex form-heading title-section form-section" style="height: 100px;">
            <p class="form-title text-center m-0 w-100" style="font-size: 35px;">
              PLEASE READ
            </p>
          </article>
          <article class="input-section form-section">
            <div class="rx-form-wrapper">
              <p>
                <strong>Florida, Kentucky, New Jersey and West Virginia Applicants: </strong>
                Please see notes below regarding State taxes or
                surcharges required.</p>

              <h5 class="strong" style="text-align: center">Claims Expenses are Outside the Limits of Liability</h5>
              <table v-if="rxApplication.customer.state != 'CA'">
                <tbody>
                <tr>
                  <th>Deductible Loss
                    & Expense</th>
                  <th>$100,000/
                    $300,000</th>
                  <th>$250,000/
                    $250,000</th>
                  <th>$500,000/
                    $500,000</th>
                  <th>$500,000/
                    $1,000,000</th>
                  <th>$1,000,000/
                    $1,000,000</th>
                </tr>
                <tr>
                  <th>
                    $1,000
                  </th>
                  <td>
                    $482
                  </td>
                  <td>
                    $510
                  </td>
                  <td>
                    $567
                  </td>
                  <td>
                    $601
                  </td>
                  <td>
                    $630
                  </td>
                </tr>
                <tr>
                  <th>
                    $2,500
                  </th>
                  <td>
                    $428
                  </td>
                  <td>
                    $455
                  </td>
                  <td>
                    $513
                  </td>
                  <td>
                    $547
                  </td>
                  <td>
                    $576
                  </td>
                </tr>
                <tr>
                  <th>
                    $5,000
                  </th>
                  <td>
                    $350
                  </td>
                  <td>
                    $378
                  </td>
                  <td>
                    $435
                  </td>
                  <td>
                    $469
                  </td>
                  <td>
                    $498
                  </td>
                </tr>

                </tbody>
              </table>
              <table v-if="rxApplication.customer.state == 'CA'">
                <tbody>
                <tr>
                  <th>Deductible Loss
                    & Expense</th>
                  <th>$100,000/
                    $300,000</th>
                  <th>$250,000/
                    $250,000</th>
                  <th>$500,000/
                    $500,000</th>
                  <th>$500,000/
                    $1,000,000</th>
                  <th>$1,000,000/
                    $1,000,000</th>
                </tr>
                <tr>
                  <th>
                    $1,000
                  </th>
                  <td>
                    $712
                  </td>
                  <td>
                    $752
                  </td>
                  <td>
                    $837
                  </td>
                  <td>
                    $887
                  </td>
                  <td>
                    $930
                  </td>
                </tr>
                <tr>
                  <th>
                    $2,500
                  </th>
                  <td>
                    $631
                  </td>
                  <td>
                    $672
                  </td>
                  <td>
                    $757
                  </td>
                  <td>
                    $807
                  </td>
                  <td>
                    $850
                  </td>
                </tr>
                <tr>
                  <th>
                    $5,000
                  </th>
                  <td>
                    $517
                  </td>
                  <td>
                    $558
                  </td>
                  <td>
                    $642
                  </td>
                  <td>
                    $693
                  </td>
                  <td>
                    $735
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
          </article>
          <article class="input-section form-section">
            <div class="d-flex align-items-center row pl-0 px-3">
              <label class="orep-label col-md-3 mb-0">
                <span class="mr-2"></span>
                Select Limits of Coverage:
              </label>
              <select
                class="orep-select col-md-3 w-100"
                name="limitOfCoverage"
                v-model="rxApplication.limitOfCoverage"
                v-validate="'required'"
                @change="getPremium()"
              >
                <option value="0.1M/0.3M">$100,000 / $300,000</option>
                <option value="0.25M/0.25M">$250,000 / $250,000</option>
                <option value="0.5M/0.5M">$500,000 / $500,000</option>
                <option value="0.5M/1M">$500,000 / $1,000,000</option>
                <option value="1M/1M">$1,000,000 / $1,000,000</option>
              </select>
            </div>

            <span 
              v-show="errors.has('limitOfCoverage')"
              class="help is-danger form-errors text-danger"
            >{{ errors.first('limitOfCoverage') | filterText }}</span>
            <label class="orep-label row mt-3 ml-0">
              Many lenders/Financial Institutions require Minimum Aggregate Limit of $1,000,000.
            </label>
            <div class="d-flex flex-row align-items-center row px-3">
              <label class="orep-label col-md-3 mb-0">
                <span class="mr-2"></span>
                Select Deductible:
              </label>
              <select
                class="orep-select col-md-3 w-100"                
                name="deductible"
                v-model="rxApplication.deductible"
                v-validate="'required'"
                @change="getPremium()"
              >
                <option value="1000">$1,000</option>
                <option value="2500">$2,500</option>
                <option value="5000">$5,000</option>
              </select>
            </div>
            <span
              v-show="errors.has('deductible')"
              class="help is-danger form-errors text-danger"
            >{{ errors.first('deductible') | filterText }}</span>

            <div class="form-inline mt-4">
              <label class="mr-2 label-price">
                <h5 class="w-100 strong">Total Annual Premium:</h5>
              </label>
              <h5 class="strong">${{(state.premium).toFixed(2)}}</h5>
            </div>
            <div class="form-inline mt-4">
              <label class="mr-2 label-price">
                <h5 class="w-100 strong">State Tax:</h5>
              </label>
              <h5 class="strong" v-show="rxApplication.customer.state != 'KY'">${{ (state.totalPremiumStateTax).toFixed(2) }}</h5>
              <h5 class="strong" v-show="rxApplication.customer.state == 'KY'">TBD</h5>
              <div class="form-inline mt-4" v-show="rxApplication.customer.state == 'KY'">
                <label>
                  <h5 class="w-100 strong">Tax will be between 5-10% depending on your County. Your Agent will calculate Tax Due After Application is Submitted. </h5>
                </label>
              </div>
            </div>
            <div class="form-inline mt-4">
              <label class="mr-2 label-price">
                <h5 class="w-100 strong">Total Premium + Tax:</h5>
              </label>
              <h5 class="strong">${{(state.total).toFixed(2)}}</h5>
            </div>
          </article>
          <article class="input-section form-section">
            <div class="radio orep-radio-wrapper" style="padding-bottom: 20px">
              <label>
                <input
                  type="radio"
                  name="oneYear"
                  value="oneYear"
                  class="orep-radio"
                  v-validate="'required|included:oneYear,twoYears'"
                  @change="getPremium()"
                  v-model="rxApplication.policyTerm"
                >
                <span class="radio-span-rx"><strong>One (1) year policy term option</strong> - Premium option selected above plus any applicable State taxes or
surcharges.</span>
              </label>
            </div>

<!--            <div class="radio orep-radio-wrapper" v-if="rxApplication.customer.state != 'CA'">-->
<!--              <label>-->
<!--                <input-->
<!--                  type="radio"-->
<!--                  name="twoYears"-->
<!--                  value="twoYears"-->
<!--                  class="orep-radio"-->
<!--                  @change="getPremium()"-->
<!--                  v-model="rxApplication.policyTerm"-->
<!--                >-->
<!--                <span class="radio-span-rx"><strong>Two (2) year policy term option</strong> - Whereby your policy limits are reinstated one year from the effective date. No renewal application will be required until the two year term has expired.                  </span>-->
<!--                </span>-->
<!--              </label>-->
<!--            </div>-->


          </article>
          <article class="input-section form-section" style="padding-right: 50px;">
            <p>
              <strong>Kentucky Residents: </strong>
              The premiums above do not include the State, City or County Taxes assessed in Kentucky. Contact your agent to obtain
              the amount of the tax prior to submitting this application.            </p>
            <p>
              <strong>West Virginia Residents: </strong>
              The State of West Virginia assesses a tax of 0.55% on insurance. Multiply premium you selected above by 1.0055 and
              round to the nearest dollar. This is the total premium and tax due.          </p>
            <p>
              <strong>Florida Residents: </strong>
              Companies writing property and casualty insurance business in the State of Florida are required to collect a Florida
              Hurricane Catastrophe surcharge. Multiply the premium you selected above by the appropriate factor and round to the
              nearest dollar. This is the total premium and surcharge due.           </p>
            <p>
              <strong>New Jersey Insurance Guaranty Association Fund: </strong>
              Companies writing property and casualty insurance business in New Jersey are required to participate in the New Jersey
              Insurance Guaranty Association. If a company becomes insolvent, the Guaranty Association settles unpaid claims and
              assesses each insurance company for its fair share. The current assessment will be displayed on your premium notice.
              Multiply the premium you selected above by the current assessment and round to the nearest dollar. This is the total
              premium and assessment due.           </p>
          </article>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'rx-application-2'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToOne()"></button>
              <button class="pagination-dots" @click="prev()"></button>
              <span class="pagination-dots pagination-current"></span>
              <button class="pagination-dots" @click="navigateToNext('rx-application-4')" :disabled="!state.pageThreeIsValid"></button>
              <button
                class="pagination-dots"
                @click="navigateToNext('rx-application-5')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('rx-application-6')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('rx-application-7')"
                  :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid|| !state.pageSixIsValid">
              </button>
            </article>
            <button
              type="submit"
              :disabled="!state.pageThreeIsValid"
              :class="{submitDisabled: !state.pageThreeIsValid}"
              class="next-btn mont spaced pull-right"
              @click="navigateToNext('rx-application-4')"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Calculating premium...</span>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "rx-application-3",
  data() {
    return {
      loading: false
    };
  },

  computed: {
    rxApplication() {
      return this.$store.state.rxApplication.rxApplication;
    },
    state() {
      return this.$store.state.rxApplication;
    },
    errorMsg() {
      return this.$store.state.rxApplication.errorMsg;
    },
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName,
      });
    },

    getPremium() {
      // this.loading = true;
      this.$store.dispatch('rxApplication/getPremium');
      this.validateBeforeSubmit();

    },

    prev() {
      this.$router.push({
        name: "rx-application-2"
      });
    },

    navigateToOne() {
      this.$router.push({
        name: "rx-application-1"
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageThreeIsValid = true;
          return;
        }
        this.state.pageThreeIsValid = false;
      });
    },
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
    //
    // if (!this.state.premium) {
    //   this.$router.push({
    //     name: "individual-appraiser-2"
    //   });
    // }
  },
};
</script>

<style scoped>
  .strong {
    font-weight: bold;
  }

  table td, table th {
    border: 1px solid black;
    padding: 20px;
    text-align: center;
  }
  table tr > td:last-child {
    width: 100px;
  }
  table tr > td:first-child {
    padding: 10px;
    text-align: center;
    max-width: 140px;
  }
  .label-price {
    width: 220px;
  }
</style>

